import React, { useState } from 'react';
import '../Poete/SubPagePoete.scss';
import { useLanguage } from '../../components/LanguageContext';

const SubPageChemin = ({ data }) => {
  const { language } = useLanguage();
  const [isMobileView] = useState(window.innerWidth <= 768);

  const getTitle = () => {
    if (!data?.title) return 'Titre non disponible';
    if (typeof data.title === 'string') return data.title;
    return data.title[language] || data.title.fr || data.title.en || 'Titre';
  };

  const getContent = () => {
    if (!data?.content) return 'Contenu non disponible';
    if (typeof data.content === 'string') return data.content;
    return data.content[language] || data.content.fr || data.content.en || 'Contenu';
  };

  if (!data) return <div>Loading...</div>;

  return (
    <div className="sub-page-left">
      {isMobileView ? (
        <>
          <div className="spl_left_content">
            <h2 className="right_title chemin-text" data-aos="fade-zoom-in"
     data-aos-easing="ease-in-back"
     data-aos-delay="300"
     data-aos-offset="0">
              {getTitle()}
            </h2>
          </div>
          {data.imageUrl && (
            <div className="spl_right_content">
              <img 
                className="right_img" 
                src={data.imageUrl} 
                alt={getTitle()} 
                data-aos="fade-left" 
                data-aos-duration="800" 
                data-aos-delay="200" 
                data-aos-offset="20"
              />
            </div>
          )}
          <div className="spl_left_content">
            <p className="left_text" data-aos="fade-in" data-aos-duration="800" data-aos-delay="400">
              {getContent().split('\n').map((line, idx) => (
                <span className="lef_text_split" key={idx}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
          </div>
        </>
      ) : (
        <>
          {data.imageUrl && (
            <div className="spl_right_content">
              <img 
                className="right_img" 
                src={data.imageUrl} 
                alt={getTitle()} 
                data-aos="fade-left" 
                data-aos-duration="800" 
                data-aos-offset="20"
              />
            </div>
          )}
          <div className="spl_left_content">
            <h2 className="right_title chemin-text" data-aos="fade-in" data-aos-duration="800">
              {getTitle()}
            </h2>
            <div>
              <p className="left_text" data-aos="fade-in" data-aos-duration="800" data-aos-delay="200">
                {getContent().split('\n').map((line, idx) => (
                  <span className="lef_text_split" key={idx}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SubPageChemin;